// extracted by mini-css-extract-plugin
export default {"mCard":"BD-z","image":"CD-z","imageNoBackground":"DD-z","imageHasCategory":"ED-z","fullWidth":"FD-z"};